import { render, staticRenderFns } from "./BpNetProfitBeforeTaxNumberDisplayer.vue?vue&type=template&id=711b0c98"
import script from "./BpNetProfitBeforeTaxNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpNetProfitBeforeTaxNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports